/**
 * Btw zoals de API hem rekent: in hele centen, één keer over het bedrag excl.
 * btw, half omhoog afgerond - zodat het scherm precies het bedrag toont dat
 * Mollie afschrijft en dat op de factuur staat. Nergens een kommagetal.
 */
export interface VatSplit {
    netCents: number;
    vatCents: number;
    totalCents: number;
}

export function withVat(netCents: number, vatPercent: number): VatSplit {
    const vatCents = Math.floor((netCents * vatPercent * 2 + 100) / 200);

    return { netCents, vatCents, totalCents: netCents + vatCents };
}

/** `"180.29"` uit de API naar hele centen. */
export function centsOf(amount: string): number {
    const [whole = '0', fraction = '0'] = amount.split('.');
    const sign = whole.startsWith('-') ? -1 : 1;

    return (
        sign *
        (Math.abs(Number.parseInt(whole, 10)) * 100 +
            Number.parseInt(fraction.padEnd(2, '0').slice(0, 2), 10))
    );
}
